import { barcodeLabelTemplateSchema } from "@redotech/redo-model/inventory/barcode-label-builder/barcode-label-definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getBarcodeLabelTemplate = {
  name: "getBarcodeLabelTemplate" as const,
  input: z.object({ templateId: zExt.objectId() }),
  output: z.object({ template: barcodeLabelTemplateSchema }),
};
